import dateFnsFormat from "date-fns/format";
import { maybeConvertToGibberish, getDateOrMillis, getUserLocale } from "./utils";
/**
 * Locale-aware version of date-fns/format
 *
 * @deprecated use {@link intlDate}
 */ export var localDate = function(date, format, userLocale) {
    return maybeConvertToGibberish(dateFnsFormat(getDateOrMillis(date), format, {
        locale: userLocale !== null && userLocale !== void 0 ? userLocale : getUserLocale()
    }));
};
